import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login/Login';
import ProtectedRoute from './Shared/ProtectedRoute';
import Dashboard from './Components/Dashboard/Dashboard';
import Template from './Components/Templates/Template';
import Experience from './Components/Experience/Experience';
import User from './Components/User.tsx/User';
import Report from './Components/Report/Report';
import ForgetPwd from './Components/Login/ForgetPwd';
import VerifyOTP from './Components/Login/VerifyOTP';
import SetPassword from './Components/Login/SetPassword';
import "../src/styles/all.scss";
import EditTemplate from './Components/Templates/EditTemplate';
import MainLayout from './Shared/MainLayout';
import EditExperience from './Components/Experience/EditExperience';
import EditPage from './Components/Experience/EditPage';
import EditUserSegement from './Components/Experience/EditUserSegement';
import EditSetCookie from './Components/Experience/EditSetCookie';
import EditRunJs from './Components/Experience/EditRunJs';
import EditShowTemplate from './Components/Experience/EditShowTemplate';
import EditViewPort from './Components/Experience/EditViewPort';
import PageMeterValue from './Components/Experience/PageMeterValue';
import PageMeter from './Components/Experience/PageMeter';
import Interaction from './Components/Experience/Interaction';

const App: React.FC = () => {
  return (
    <Router>
    
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forget-password" element={<ForgetPwd />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route element={<ProtectedRoute />}>
          <Route path="/" element={<MainLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/templates/list" element={<Template />} />
          <Route path="/edit-template/:id" element={<EditTemplate />} />
          <Route path="/experience/list" element={<Experience />} />
          <Route path="/edit-experience/:id?" element={<EditExperience />} />
          <Route path="/edit-experience/:id/setting" element={<EditExperience />} />
          <Route path="/edit-page/:id?" element={<EditPage />} />
          <Route path="/edit-user-segment/:id?" element={<EditUserSegement />} />
          <Route path="/edit-run-js/:id?" element={<EditRunJs />} />
          <Route path="/edit-set-cookie/:id?" element={<EditSetCookie />} />
          <Route path="/edit-show-template/:id?" element={<EditShowTemplate />} />
          <Route path="/edit-view-port/:id?" element={<EditViewPort />} />
          <Route path="/edit-page-meter/:id?" element={<PageMeter />} />
          <Route path="/edit-page-value/:id?" element={<PageMeterValue />} />
          <Route path="/edit-interaction/:id?" element={<Interaction />} />
          <Route path="/users" element={<User />} />
          <Route path="/report" element={<Report />} />
          </Route>
          </Route>
        </Routes>
    </Router>
  );
};

export default App;